<mat-toolbar class="container-header">
    <mat-toolbar-row class="nav_logo">
        <img class="logo" src="assets/images/logo_navbar_blanco.svg" alt="logo de InventigAr"
        routerLink="/home" routerLinkActive="active">    
    </mat-toolbar-row>  
</mat-toolbar>